App.filter('dateFormatterFullYear', function () {
    return function (miliSec) {
        miliSec = miliSec || '';
        if (miliSec) {
            var time = new Date(miliSec);

            var year = time.getFullYear();
            
            var all = year;
        }
        return all;
    };
})